import { render, staticRenderFns } from "./leadsCanban.vue?vue&type=template&id=b18b318e&scoped=true&"
import script from "./leadsCanban.vue?vue&type=script&lang=js&"
export * from "./leadsCanban.vue?vue&type=script&lang=js&"
import style0 from "./leadsCanban.vue?vue&type=style&index=0&id=b18b318e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18b318e",
  null
  
)

export default component.exports